import React, { useState, useEffect, useRef } from "react";
import { useDispatch } from "react-redux";
import "./whatsAppChat.css";
import { SearchOutlined, AttachFile } from "@material-ui/icons";
import Switch from "@mui/material/Switch";
import PreviewRoundedIcon from "@mui/icons-material/PreviewRounded";
import WhatsAppChatStartModal from "./whatsappChatStartModal";
import { ACTIONS } from "../../interfaces/actionTypes/OffLineSupportType";
import { ACTIONS as ACTIONSLOGIN } from "../../../interfaces/actionTypes/loginTypes";
import { Avatar, IconButton } from "@material-ui/core";
import Tooltip from "@mui/material/Tooltip";
import DownloadForOfflineIcon from "@mui/icons-material/DownloadForOffline";
import Button from "@mui/material/Button";
import { connect } from "react-redux";
import Loader from "../../../redcliffe.gif";
import moment from "moment";
import Pagination from "@mui/material/Pagination";
import {
  getWhatsappComments,
  getIndividualWhatsappChat,
  sendWhatsappComments,
  addComment,
  getPositiveCallsComments,
  signOutInWhatsappChat,
  resetLeadDetails,
  getUserDetails,
  clickToCall,
} from "../../actions/OffLineSupportActions";
import {
  getWhatsappStatus,
  getAgentList,
  postModuleInteraction,
} from "../../../actions/loginActions";
import CloseIcon from "@material-ui/icons/Close";
import ReplayIcon from "@mui/icons-material/Replay";
import WhatsAppModal from "../Comments/whatsappModal";
import SendIcon from "@mui/icons-material/Send";
import { styled } from "@mui/material/styles";
import DoneIcon from "@mui/icons-material/Done";
import DoneAllIcon from "@mui/icons-material/DoneAll";
import DocModal from "../../../components/ImageModal/index";

const Input = styled("input")({
  display: "none",
});

const LeftContainerComponent = (props) => {
  const {
    row,
    index,
    agentSkill,
    setTabData,
    tabData,
    messageData,
    specificMessage,
    whatsAppTabs,
  } = props;

  return (
    <div
      key={index}
      className="whatsAppCallNamesSingle"
      style={messageData?.id === row?.id ? { backgroundColor: "#ebebeb" } : {}}
      onClick={() => {
        let newTabConatiner = [];
        newTabConatiner =
          tabData?.length > 0 &&
          tabData.filter((leftMan) => {
            if (leftMan?.id && row?.id && leftMan?.id !== row?.id) {
              return leftMan;
            }
          });
        row["notification"] = false;
        row["count"] = 0;
        if (newTabConatiner?.length && row?.id) {
          setTabData([...newTabConatiner, row]);
        } else {
          setTabData([row]);
        }
        specificMessage(
          row?.id,
          row?.latest_chat_id,
          row?.patient_name,
          row?.latest_chat_created_at,
          row?.id,
          row?.mobile
        );
      }}
    >
      <div className="sidebarChat">
        <Avatar src={`https://avatars.dicebear.com/api/human/${row?.id}.svg`} />
        <div className="sidebarChat_info">
          <h2>
            {row?.patient_name} - {row?.id}
          </h2>
          <p style={{ marginBottom: "6px" }}>
            {new Date(row?.latest_chat_created_at).toLocaleString()}
          </p>
        </div>
      </div>
    </div>
  );
};

const WhatsAppChat = ({
  getWhatsappComments,
  whatsappComments,
  getIndividualWhatsappChat,
  individualWhatsappChat,
  sendWhatsappComments,
  addComment,
  getPositiveCallsComments,
  todays_positive_calls,
  whatsappDataFromPusher,
  loading,
  loadingChat,
  loadingIndividualChat,
  signOutInWhatsappChat,
  failedReport,
  resetLeadDetails,
  latestBookingUsingLeadData,
  userDetails,
  getUserDetails,
  signOutData,
  clickToCall,
  chatAssignedFromPusher,
  chatUnassignedFromPusher,
  getWhatsappStatus,
  whatsappStatusMessageId,
  startWhatsappChatData,
  getAgentList,
  agentsList,
  postModuleInteraction,
}) => {
  const ref = useRef();
  let dispatch = useDispatch();
  const searchRef = useRef();
  const [tabs, settabs] = useState(1);
  const [tabs1, settabs1] = useState(2);
  const [chats, setChats] = useState("");
  const [messageData, setmessageData] = useState({
    id: "",
    patient_name: "",
    dateThen: "",
    lead: "",
    mobile: "",
  });
  const [leadIdSearch, setleadIdSearch] = useState("");
  const [tabLeadColor, setTabLeadColor] = React.useState(0);
  const [id, setId] = useState("");
  const [currentSelectedLead, setCurrentSelectedLead] = useState("");
  const [openFloat, setOpenFloat] = React.useState(false);
  const [show, setShow] = useState(false);
  const [fileType, setFileType] = useState("");
  const [whatsAppTabs, setWhatsAppTabs] = useState("All");
  const [messageType, setMessageType] = useState("");
  const [leadUnread, setLeadUnread] = useState([]);
  const [leadUnreadMessageId, setLeadUnreadMessageId] = useState([]);
  const [loadMoreChats, setLoadMoreChats] = useState(false);
  const [loadMoreChatsPage, setLoadMoreChatsPage] = useState(2);
  const [leftContainer, setLeftContainer] = useState([]);
  const [tabData, setTabData] = useState([]);
  const [pagination, setPagination] = React.useState(1);
  const [key, setKey] = React.useState(false);
  const [customerDetails, setCustomerDetails] = useState("");
  const [objId, setObjId] = useState("");
  const [whatsappTemplateShow, setWhatsappTemplateShow] = React.useState(false);
  const [openWhatsapp, setOpenWhatsapp] = React.useState(false);
  const [whatsappLeadSearch, setWhatsappLeadSearch] = React.useState("");
  const [openReportModal, setOpenReportModal] = useState(false);
  const [cityId, setCityId] = useState("");
  const [customer_city, setCustomer_city] = useState("");
  const [dateOfLastMsgArray, setDateOfLastMsgArray] = useState("");
  const [dateOfLastMsg, setDateOfLastMsg] = useState("");
  const [personId, setPersonId] = React.useState("none");
  let dateYesterday = new Date();
  const [packageDetails, setPackageDetails] = useState([]);
  const [packages, setPackages] = useState([]);
  dateYesterday.setDate(dateYesterday.getDate() - 1);

  const [checked, setChecked] = useState(userDetails?.profile?.offline_chat);
  const [messageSource, setMessageSource] = React.useState("messageSource");
  const [startChatModal, setStartChatModal] = useState(false);
  const [customerDetailsModal, setCustomerDetailsModal] = useState(false);
  const [linkOfTheDoc, setLinkOfTheDoc] = useState("");
  const [openDoc, setOpenDoc] = useState(false);
  const [unassignedLeadId, setLeadUnAssignLeadId] = useState("");

  const handleChange = (event) => {
    setChecked(event.target.checked);
    let body = {
      get_chat: event.target.checked,
      offline: true,
    };
    signOutInWhatsappChat(event.target.checked, body);
    let data = {
      module: "chat",
      sub_module: event.target.checked === true ? "sign_in" : "sign_out",
      panel_user_id: userDetails?.profile?.id,
    };
    postModuleInteraction(data);
  };

  useEffect(() => {
    if (signOutData?.msg === "success") {
      setTimeout(() => {
        getUserDetails("?refresh=true");
      }, 1000);
    }
  }, [signOutData]);

  useEffect(() => {
    const runAfterPageLoad = () => {
      setLeadUnread([]);
      resetLeadDetails();
      scrollToBottom();
    };
    window.onload = runAfterPageLoad;
    return () => {
      window.onload = null;
    };
  }, []);

  useEffect(() => {
    const runAfterPageLoad = () => {
      setLeadUnread([]);
      resetLeadDetails();
      scrollToBottom();
    };
    window.onload = runAfterPageLoad;
    return () => {
      window.onload = null;
    };
  }, []);

  useEffect(() => {
    scrollToBottom();
    getWhatsappComments("offline_support=true");
  }, []);

  const handleClickWhatsapp = () => {
    setOpenWhatsapp(true);
  };

  useEffect(() => {
    if (startWhatsappChatData?.length > 0 && startWhatsappChatData[1] === 201) {
      dispatch({ type: ACTIONSLOGIN.START_WHATSAPP_CHAT, payload: [] });
      getIndividualWhatsappChat(`lead=${messageData.id}`);
    }
  }, [startWhatsappChatData]);

  useEffect(() => {
    if (!loadMoreChats) {
      setLeadUnread(individualWhatsappChat?.results);
      const arrayOfMessageId = individualWhatsappChat?.results
        ?.filter((messageType) => messageType?.msgtype === "2")
        .map((message) => {
          return message.messageid;
        });
      setLeadUnreadMessageId(arrayOfMessageId);
      if (individualWhatsappChat?.results) {
        setDateOfLastMsgArray(
          individualWhatsappChat?.results.filter(function (el) {
            return el.msgtype === "1";
          })
        );
      }
    } else if (loadMoreChats) {
      const arrayOfMessageId = individualWhatsappChat?.results
        ?.filter((messageType) => messageType?.msgtype === "2")
        .map((message) => {
          return message.messageid;
        });
      setLeadUnreadMessageId([...leadUnreadMessageId, ...arrayOfMessageId]);
      setLeadUnread([...leadUnread, ...individualWhatsappChat?.results]);
      setLoadMoreChats(false);
    }
    if (individualWhatsappChat && individualWhatsappChat?.count > 0)
      setMessageSource(individualWhatsappChat?.results[0]?.message_source);
  }, [individualWhatsappChat]);

  useEffect(() => {
    if (leadUnreadMessageId?.length > 0) {
      const arrayLength = leadUnreadMessageId?.length;
      const textLength = leadUnreadMessageId.toString().length + 1;
      if (arrayLength !== textLength) {
        getWhatsappStatus(`${leadUnreadMessageId.toString()}`);
      }
    }
  }, [leadUnreadMessageId]);

  useEffect(() => {
    if (whatsappStatusMessageId?.length > 0) {
      whatsappStatusMessageId.map((row) => {
        leadUnread &&
          leadUnread?.length > 0 &&
          leadUnread.forEach((message) => {
            if (row?.msg_id === message?.messageid) {
              message["tick"] = row?.status;
            }
            return message;
          });
      });
    }
  }, [leadUnread, whatsappStatusMessageId]);

  useEffect(() => {
    if (loadMoreChats) {
      setLoadMoreChatsPage(loadMoreChatsPage + 1);
      getIndividualWhatsappChat(
        `lead=${messageData.id}&page=${loadMoreChatsPage}`
      );
    }
  }, [loadMoreChats]);

  useEffect(() => {
    if (dateOfLastMsgArray?.length > 0) {
      setDateOfLastMsg(dateOfLastMsgArray[0]?.created_at);
    } else {
      setWhatsappTemplateShow(true);
    }
  }, [dateOfLastMsgArray]);

  useEffect(() => {
    let timeDiff = moment(dateYesterday).isAfter(dateOfLastMsg);

    if (timeDiff === false) {
      setWhatsappTemplateShow(false);
    } else {
      setWhatsappTemplateShow(true);
    }
  }, [dateOfLastMsg]);

  useEffect(() => {
    if (tabData?.length === 0) {
      setmessageData({
        id: "",
        patient_name: "",
        dateThen: "",
        lead: "",
        mobile: "",
      });
    }
  }, [tabData]);

  useEffect(() => {
    setLeftContainer(whatsappComments?.results);
  }, [whatsappComments]);

  useEffect(() => {
    setLeadUnread([]);
    setLeadUnreadMessageId([]);
    resetLeadDetails();
  }, []);

  const AllChats = () => {
    setleadIdSearch("");
    setWhatsAppTabs("All");
    settabs(1);
    setPagination(1);
    getWhatsappComments("offline_support=true");
    setCityId("");
    setPackages([]);
    setPackageDetails([]);
  };
  const directChats = () => {
    setleadIdSearch("");
    setWhatsAppTabs("direct_chat");
    settabs(4);
    setPagination(1);
    getWhatsappComments(`offline_support=true&get_all=true`);
    setCityId("");
    setPackages([]);
    setPackageDetails([]);
  };

  const chat = (data) => {
    settabs1(data);
    if (data === 1) {
    }
    if (data === 2) {
      getIndividualWhatsappChat(`lead=${messageData.id}`);
    }
  };
  const specificMessage = (
    lead,
    mid,
    patient_name,
    msgDate,
    leadId,
    mobile
  ) => {
    setmessageData({
      id: lead,
      patient_name: patient_name,
      dateThen: msgDate,
      lead: leadId,
      mobile:mobile
    });
    setTabLeadColor(lead);
    settabs1(2);
    setLoadMoreChats(false);
    setLoadMoreChatsPage(2);
    setChats("");
    setMessageType("");
    setFileNameValue("");
    setFileName("");
    setShow(false);
    setCityId("");
    setPackages([]);
    setPackageDetails([]);
    dispatch({ type: ACTIONS.GET_PACKAGES, payload: [] });
    setCurrentSelectedLead(lead);
    setId(mid);
    getPositiveCallsComments(lead);
    getIndividualWhatsappChat(`lead=${lead}`);
  };

  const sendMessage = async (e) => {
    e.preventDefault();
    let formData = new FormData();
    formData.append("file_name", fileNameValue);
    formData.append("message", fileNameValue);
    formData.append(
      "message_type",
      messageType === "application/pdf" ? "document" : "image"
    );
    formData.append("file", fileName);
    let body = {
      comment: chats,
      callId: currentSelectedLead,
    };
    const body3 = { message: chats };
    const body4 = { message: chats, from_support: true };

    if (tabs1 === 1) {
      addComment(body);
      setChats("");
      getIndividualWhatsappChat(`lead=${messageData.id}`);
      setleadIdSearch(currentSelectedLead);
      setPagination(1);
      getWhatsappComments(`offline_support=true&search=${currentSelectedLead}`);
    }
    if (tabs1 === 2) {
      if (body3 === "") {
        alert("Please Provide Message.");
      } else {
        setChats("");
        setPackages([]);
        setPackageDetails([]);
        setMessageType("");
        setFileNameValue("");
        setFileName("");
        await sendWhatsappComments(
          individualWhatsappChat?.results[0]?.lead,
          (messageType === "") & (whatsAppTabs === "direct_chat")
            ? body4
            : messageType === "" && whatsAppTabs !== "direct_chat"
            ? body3
            : formData
        );
        if (tabData !== undefined && messageData?.id) {
          let newTabConatiner = [];
          newTabConatiner = tabData.filter((leftMan) => {
            if (leftMan?.id && leftMan?.id === messageData?.id) {
              leftMan["notification"] = false;
              leftMan["count"] = 0;
              return leftMan;
            } else {
              return leftMan;
            }
          });
          newTabConatiner.length &&
            whatsappDataFromPusher?.id !== undefined &&
            whatsappDataFromPusher?.id !== "undefined" &&
            setTabData([...newTabConatiner]);
        }
        await getIndividualWhatsappChat(`lead=${messageData.id}`);
        if (individualWhatsappChat?.results[0]?.msgtype === "1") {
          if (leadIdSearch !== "") {
            setPagination(1);
            await getWhatsappComments(
              `offline_support=true&search=${leadIdSearch}`
            );
          } else {
            setLeftContainer([]);
            setPagination(1);
            getWhatsappComments("offline_support=true");
          }
        }
      }
    }
  };

  const scrollToBottom = () => {
    ref?.current?.scrollIntoView({ behavior: "smooth" });
  };

  const handleKeyDown = (event) => {
    if (event.key === "Enter") {
      setPagination(1);
      getWhatsappComments(
        `offline_support=true&get_all=true&search=${leadIdSearch}`
      );
    }
  };

  const [fileName, setFileName] = useState();
  const [fileNameValue, setFileNameValue] = useState("");
  const handleFileChange = async (e, type) => {
    setFileType(type);
    setFileName(e.target.files[0]);
    setMessageType(e.target.files[0]?.type);
    setFileNameValue(e.target.files[0]?.name);
    setChats(e.target.files[0]?.name);
    setOpenFloat(false);
    setShow(!show);
    setKey(!key);
  };

  const handleDownloadFile = (url) => {
    fetch(url).then(function (t) {
      return t.blob().then((b) => {
        var a = document.createElement("a");
        a.href = URL.createObjectURL(b);
        a.setAttribute("download", url);
        a.click();
      });
    });
  };

  useEffect(() => {
    if (
      leadUnread !== undefined &&
      leftContainer !== undefined &&
      whatsappDataFromPusher?.id
    ) {
      let newLeftContainer = [];
      let tmpLeftMan = {};
      if (messageData?.id && messageData?.id === whatsappDataFromPusher?.id) {
        setLeadUnread([whatsappDataFromPusher, ...leadUnread]);
        setWhatsappTemplateShow(false);
      }
      newLeftContainer = leftContainer.filter((leftMan) => {
        if (leftMan?.id && leftMan?.id !== whatsappDataFromPusher?.id) {
          return leftMan;
        }
      });
      if (
        newLeftContainer.length &&
        whatsappDataFromPusher?.id !== undefined &&
        whatsappDataFromPusher?.id !== "undefined"
      ) {
        setLeftContainer([whatsappDataFromPusher, ...newLeftContainer]);
      }
    }
    if (tabData !== undefined && whatsappDataFromPusher?.id) {
      let newTabConatiner = [];
      newTabConatiner = tabData.filter((leftMan) => {
        if (leftMan?.id && leftMan?.id === whatsappDataFromPusher?.id) {
          leftMan["notification"] = true;
          leftMan["count"] = leftMan["count"] + 1;
          return leftMan;
        } else {
          leftMan["notification"] = false;
          leftMan["count"] = 0;
          return leftMan;
        }
      });
      newTabConatiner.length &&
        whatsappDataFromPusher?.id !== undefined &&
        whatsappDataFromPusher?.id !== "undefined" &&
        setTabData([...newTabConatiner]);
    }
  }, [whatsappDataFromPusher]);

  useEffect(() => {
    if (leftContainer !== undefined && chatAssignedFromPusher?.id) {
      setLeftContainer([chatAssignedFromPusher, ...leftContainer]);
    }
  }, [chatAssignedFromPusher]);

  useEffect(() => {
    if (
      leadUnread !== undefined &&
      leftContainer !== undefined &&
      chatUnassignedFromPusher?.id
    ) {
      let newLeftContainer = [];

      newLeftContainer = leftContainer.filter((leftMan) => {
        if (leftMan?.id && leftMan?.id !== chatUnassignedFromPusher?.id) {
          return leftMan;
        }
        setLeadUnAssignLeadId(chatUnassignedFromPusher?.id);
      });

      newLeftContainer.length &&
        setLeftContainer([...newLeftContainer]) &&
        setTabData([...newLeftContainer]);
    }
    if (tabData !== undefined && chatUnassignedFromPusher?.id) {
      let newTabConatiner = [];
      newTabConatiner = tabData.filter((leftMan) => {
        if (leftMan?.id && leftMan?.id !== chatUnassignedFromPusher?.id) {
          return leftMan;
        }
      });
      newTabConatiner.length &&
        chatUnassignedFromPusher?.id !== undefined &&
        chatUnassignedFromPusher?.id !== "undefined" &&
        setTabData([...newTabConatiner]);
    }
  }, [chatUnassignedFromPusher]);

  const limit = whatsappComments?.count / 20;
  let fetchinPage = false;

  const handleChangePage = (event, newPage) => {
    if (whatsAppTabs === "All") {
      getWhatsappComments(`offline_support=true&page=${newPage}`);
    } else if (whatsAppTabs === "hold") {
      getWhatsappComments(`offline_support=true&page=${newPage}`);
    } else if (whatsAppTabs === "unread") {
      getWhatsappComments(`offline_support=true&page=${newPage}`);
    }
    setPagination(newPage);
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    sendMessage(event);
  };

  useEffect(() => {
    if (userDetails?.profile?.offline_chat === true) {
      setChecked(true);
    }
  }, [userDetails]);

  useEffect(() => {
    if (
      latestBookingUsingLeadData &&
      latestBookingUsingLeadData?.result?.length > 0
    ) {
      setOpenReportModal(true);
    }
  }, [latestBookingUsingLeadData]);

  const [bookingIdReport, setBookingIdReport] = React.useState("");
  const [addBookingIdReport, setAddBookingIdReport] = React.useState("");

  const handleReportData = (event, data) => {
    if (data?.add_booking_id !== null) {
      setAddBookingIdReport(data?.add_booking_id);
      setBookingIdReport("");
    } else {
      setBookingIdReport(data?.booking_id);
      setAddBookingIdReport("");
    }
  };

  useEffect(() => {
    if (!performance.getEntriesByType("navigation")[0].domComplete) {
      getUserDetails("?refresh=true");
    }
  }, []);

  const handleCallClick = (id, type) => {
    clickToCall(id, type);
  };

  const [agentSkill, setAgentSkill] = useState("");

  useEffect(() => {
    getAgentList(`self=true`);
  }, []);

  useEffect(() => {
    if (
      agentsList?.count > 0 &&
      agentsList?.results[0]?.chat_skills?.length > 0
    )
      setAgentSkill(agentsList?.results[0]?.chat_skills[0]?.type);
  }, [agentsList]);

  const [timeUpdate, setTimeUpdate] = useState(new Date());

  useEffect(() => {
    const interval = setInterval(() => {
      setTimeUpdate(new Date());
    }, 1000);

    return () => clearInterval(interval);
  }, []);

  return (
    <div className="app">
      <div className="app_body">
        <div className="sidebar">
          <div style={{ height: "105px" }}>
            <div className="sidebar_header">
              <div
                className="sidebar_headerRight"
                style={{ width: "100%", flexDirection: "column" }}
              >
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    padding: "10px",
                  }}
                >
                  <h2
                    style={{ fontSize: "16px", fontWeight: "900", margin: 0 }}
                  >
                    Whatsapp Chat
                  </h2>
                  <Switch
                    checked={checked}
                    onChange={handleChange}
                    color="success"
                    inputProps={{ "aria-label": "controlled" }}
                  />
                </div>
              </div>
            </div>

            <div className="sidebar_search">
              <div className="sidebar_searchContainer">
                <SearchOutlined />
                <input
                  placeholder="Search booking, lead, ph number"
                  value={leadIdSearch}
                  onChange={(e) =>
                    setleadIdSearch(e.target.value.replace(/[^0-9]/, ""))
                  }
                  ref={searchRef}
                  onKeyDown={handleKeyDown}
                />
              </div>
            </div>
          </div>
          <div className="whatsAppCallTab">
            <div
              // onClick={() => changePanel(1)}
              onClick={() => AllChats()}
              style={
                tabs === 1 || whatsAppTabs === "All"
                  ? {
                      borderBottom: "2px solid #7569B3",
                      color: "#7569B3",
                      fontWeight: "600",
                      backgroundColor: "#bebedb",
                    }
                  : {
                      borderBottom: "2px solid #D3D3D3",
                      color: "#D3D3D3",
                      fontWeight: "600",
                      backgroundColor: "#ffffff",
                    }
              }
            >
              <h2 style={{ fontSize: "16px" }}>Active</h2>
            </div>

            <div
              onClick={() => directChats()}
              style={
                tabs === 4 || whatsAppTabs === "direct_chat"
                  ? {
                      borderBottom: "2px solid #7569B3",
                      color: "#7569B3",
                      fontWeight: "600",
                      backgroundColor: "#bebedb",
                    }
                  : {
                      borderBottom: "2px solid #D3D3D3",
                      color: "#D3D3D3",
                      fontWeight: "600",
                      backgroundColor: "#ffffff",
                    }
              }
            >
              <h2 style={{ fontSize: "16px" }}>Direct Chats</h2>
            </div>
          </div>
          <div className="sidebar_chats">
            {loading ? (
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  width: "100%",
                  height: "100%",
                }}
              >
                <img src={Loader} width="80" height="80" />
              </div>
            ) : leftContainer?.length > 0 ? (
              leftContainer.map((row, index) => {
                return (
                  <LeftContainerComponent
                    row={row}
                    timeUpdate={timeUpdate}
                    index={index}
                    agentSkill={agentSkill}
                    setTabData={setTabData}
                    tabData={tabData}
                    messageData={messageData}
                    specificMessage={specificMessage}
                    whatsAppTabs={whatsAppTabs}
                  />
                );
              })
            ) : (
              <p
                style={{ fontSize: "16px", fontWeight: "700", padding: "10px" }}
              >
                Please Wait. No Chats are available. We'll be assigning new
                chats soon.
              </p>
            )}
            {leftContainer?.length > 0 &&
            whatsappComments?.count > whatsappComments?.page_size ? (
              <Pagination
                count={Math.ceil(whatsappComments?.count / 20) || 0}
                page={pagination}

                onChange={handleChangePage}
                disabled={loading}
              />
            ) : (
              ""
            )}
          </div>
        </div>
        <div className="chat">
          <div className="chat_header_upper">
            {tabData?.length > 0 &&
              tabData.map((row, index) => (
                <div
                  style={
                    tabLeadColor === row?.id
                      ? {
                          backgroundColor: "#ebebeb",
                          display: "flex",
                          cursor: "pointer",
                          paddingTop: "3px",
                          paddingLeft: "16px",
                          borderRadius: "15px 15px 0px 0px",
                        }
                      : {
                          display: "flex",
                          cursor: "pointer",
                          paddingTop: "3px",
                          paddingLeft: "16px",
                          borderRadius: "0px 0px 15px 15px",
                        }
                  }
                  className="tab"
                >
                  <button
                    className="tablinks"
                    style={{
                      fontSize: "16px",
                      padding: "3px 10px 3px 0px",
                      cursor: "pointer",
                      width: "140px",
                      height: "40px",
                      whiteSpace: "nowrap",
                      overflow: "hidden",
                      backgroundColor:
                        row.notification === true ? "#f8de7e85" : "",
                      textOverflow: "ellipsis",
                      fontWeight: "700",
                    }}
                    onClick={() => {
                      row["notification"] = false;
                      row["count"] = 0;
                      specificMessage(
                        row?.id,
                        row?.latest_chat_id,
                        row?.patient_name,
                        row?.latest_chat_created_at,
                        row?.id,
                        row.mobile
                      );
                    }}
                  >
                    {/* <BlinkedButton/> */}
                    {row?.patient_name ? row?.patient_name : row?.id}
                    {row?.count === 0 ? "" : `(${row?.count})`}
                  </button>
                  <CloseIcon
                    className="cross"
                    style={{ padding: "2px" }}
                    onClick={() => {
                      const list = [...tabData];
                      list.splice(index, 1);
                      if (
                        tabLeadColor === tabData[index]?.id &&
                        tabData?.length > 1
                      ) {
                        let num = index === 0 ? 1 : index - 1;
                        specificMessage(
                          tabData[num]?.id,
                          tabData[num]?.latest_chat_id,
                          tabData[num]?.patient_name,
                          tabData[num]?.latest_chat_created_at,
                          tabData[num]?.id
                        );
                      }
                      setTabData(list);
                    }}
                  />
                </div>
              ))}
          </div>
          {messageData?.id && tabData?.length > 0 ? (
            <div className="chat_header">
              <Avatar
                src={`https://avatars.dicebear.com/api/human/${messageData?.id}.svg`}
              />
              <div className="chat_headerInfo">
                <h3>{messageData?.patient_name}</h3>
                <p>Mobile - {messageData?.mobile}</p>
              </div>
              <div className="chat_headerRight"></div>
              <div className="toggleChats">
                <p
                  onClick={() => chat(2)}
                  style={
                    tabs1 === 2
                      ? {
                          borderBottom: "2px solid #7569B3",
                          color: "#7569B3",
                          fontWeight: "600",
                          height: "100%",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          width: "40%",
                          cursor: "pointer",
                        }
                      : {
                          borderBottom: "2px solid #D3D3D3",
                          color: "#D3D3D3",
                          fontWeight: "600",
                          height: "100%",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          width: "40%",
                          cursor: "pointer",
                        }
                  }
                >
                  Chats
                </p>
              </div>
            </div>
          ) : null}
          <div className="chat_body">
            {tabs1 === 2 && tabData?.length > 0 && leadUnread?.length > 0
              ? [...leadUnread].map((row, index) => (
                  <>
                    <p
                      className={`chat_message ${
                        row?.msgtype === "2" && "chat_receiver"
                      }`}
                    >
                      <span className="chat_name">
                        {row?.msgtype === "2"
                          ? row?.panel_user
                          : row?.patient_name}
                      </span>
                      {row?.file_url === "" || row?.file_url === null ? (
                        row?.message ? (
                          row?.message
                            .split("\n")
                            .map((line) => <p>{line.replace(/%20/g, " ")}</p>)
                        ) : (
                          ""
                        )
                      ) : (
                        <>
                          {row?.file_url?.includes("pdf") ? (
                            row?.msgtype === "2" ? (
                              <div
                                style={{
                                  display: "flex",
                                  flexDirection: "column",
                                  alignItems: "flex-end",
                                }}
                              >
                                <Tooltip
                                  title="Click on the icon to view the pdf"
                                  arrow
                                  followCursor
                                >
                                  <div>
                                    <embed
                                      src={
                                        row?.file_url?.includes("http")
                                          ? `${row?.file_url}`
                                          : `https://report.redcliffelabs.com/${row?.file_url}`
                                      }
                                      alt="whatsapp_image"
                                      style={{
                                        width: "300px",
                                        height: "100px",
                                        padding: "20px 0px 0px 0px",
                                      }}
                                    />
                                  </div>
                                </Tooltip>
                                <div
                                  className="download_icon"
                                  style={{
                                    display: "flex",
                                    flexDirection: "row",
                                    justifyContent: "space-between",
                                    width: "300px",
                                  }}
                                >
                                  <PreviewRoundedIcon
                                    style={{ width: "32px", height: "32px" }}
                                    onClick={() => {
                                      setLinkOfTheDoc(
                                        row?.file_url?.includes("http")
                                          ? `${row?.file_url}`
                                          : `https://report.redcliffelabs.com/${row?.file_url}`
                                      );
                                      setOpenDoc(true);
                                    }}
                                  />
                                  <div
                                    className="chat_timestamp"
                                    style={{
                                      marginTop: "10px",
                                      display: "flex",
                                      justifyContent: "space-between",
                                    }}
                                  >
                                    {row?.created_at ? (
                                      <span style={{ fontSize: "12px" }}>
                                        {new Date(
                                          row?.created_at
                                        ).toLocaleString()}
                                      </span>
                                    ) : (
                                      <span style={{ fontSize: "12px" }}>
                                        {new Date(
                                          row?.latest_chat_created_at
                                        ).toLocaleString()}
                                      </span>
                                    )}
                                    {row?.tick === "sent" ? (
                                      <p
                                        style={{
                                          color: "black",
                                          margin: "0",
                                          textAlign: "right",
                                          paddingLeft: "14px",
                                        }}
                                      >
                                        <DoneIcon />
                                      </p>
                                    ) : row?.tick === "read" ? (
                                      <p
                                        style={{
                                          color: "#365beee8",
                                          margin: "0",
                                          textAlign: "right",
                                          paddingLeft: "14px",
                                        }}
                                      >
                                        <DoneAllIcon />
                                      </p>
                                    ) : row?.tick === "delivered" ? (
                                      <p
                                        style={{
                                          color: "black",
                                          margin: "0",
                                          textAlign: "right",
                                          paddingLeft: "14px",
                                        }}
                                      >
                                        <DoneAllIcon />
                                      </p>
                                    ) : (
                                      ""
                                    )}
                                  </div>
                                </div>
                              </div>
                            ) : (
                              <div
                                style={{
                                  display: "flex",
                                  flexDirection: "column",
                                  alignItems: "flex-end",
                                }}
                              >
                                <Tooltip
                                  title="Click on the icon to view the pdf"
                                  arrow
                                  followCursor
                                >
                                  <div>
                                    <img
                                      src={`https://is4-ssl.mzstatic.com/image/thumb/Purple122/v4/6d/d2/02/6dd2028a-ef9d-9166-9848-bbf9fefde374/AppIcon-0-0-1x_U007emarketing-0-0-0-7-0-0-sRGB-0-0-0-GLES2_U002c0-512MB-85-220-0-0.png/460x0w.webp`}
                                      alt="whatsapp_image"
                                      style={{
                                        width: "300px",
                                        height: "100px",
                                        padding: "20px 0px 0px 0px",
                                      }}
                                    />
                                  </div>
                                </Tooltip>
                                <div
                                  className="download_icon"
                                  style={{
                                    display: "flex",
                                    flexDirection: "row",
                                    justifyContent: "space-between",
                                    width: "300px",
                                  }}
                                >
                                  <PreviewRoundedIcon
                                    style={{ width: "32px", height: "32px" }}
                                    onClick={() => {
                                      setLinkOfTheDoc(
                                        row?.file_url?.includes("http")
                                          ? `${row?.file_url}`
                                          : `https://report.redcliffelabs.com/${row?.file_url}`
                                      );
                                      setOpenDoc(true);
                                    }}
                                  />
                                  <div
                                    className="chat_timestamp"
                                    style={{
                                      marginTop: "10px",
                                      display: "flex",
                                      justifyContent: "space-between",
                                    }}
                                  >
                                    {row?.created_at ? (
                                      <span style={{ fontSize: "12px" }}>
                                        {new Date(
                                          row?.created_at
                                        ).toLocaleString()}
                                      </span>
                                    ) : (
                                      <span style={{ fontSize: "12px" }}>
                                        {new Date(
                                          row?.latest_chat_created_at
                                        ).toLocaleString()}
                                      </span>
                                    )}
                                    {row?.tick === "sent" ? (
                                      <p
                                        style={{
                                          color: "black",
                                          margin: "0",
                                          textAlign: "right",
                                          paddingLeft: "14px",
                                        }}
                                      >
                                        <DoneIcon />
                                      </p>
                                    ) : row?.tick === "read" ? (
                                      <p
                                        style={{
                                          color: "#365beee8",
                                          margin: "0",
                                          textAlign: "right",
                                          paddingLeft: "14px",
                                        }}
                                      >
                                        <DoneAllIcon />
                                      </p>
                                    ) : row?.tick === "delivered" ? (
                                      <p
                                        style={{
                                          color: "black",
                                          margin: "0",
                                          textAlign: "right",
                                          paddingLeft: "14px",
                                        }}
                                      >
                                        <DoneAllIcon />
                                      </p>
                                    ) : (
                                      ""
                                    )}
                                  </div>
                                </div>
                              </div>
                            )
                          ) : row?.file_url?.includes("https://youtu.be/") ||
                            row?.file_url?.includes(
                              "https://www.youtube.com/"
                            ) ? (
                            <div
                              style={{
                                display: "flex",
                                flexDirection: "column",
                                alignItems: "flex-end",
                              }}
                            >
                              <img
                                src={
                                  row?.file_url?.includes("https://youtu.be/")
                                    ? `https://img.youtube.com/vi/${(row?.file_url).slice(
                                        17
                                      )}/0.jpg`
                                    : `https://img.youtube.com/vi/${(row?.file_url).slice(
                                        32
                                      )}/0.jpg`
                                }
                                alt="youtube_image"
                                style={{
                                  width: "300px",
                                  height: "200px",
                                  padding: "20px 0px 0px 0px",
                                }}
                              />
                              <Tooltip
                                title="Click on the link to open the video in new tab"
                                arrow
                                followCursor
                              >
                                <a
                                  id="downloadtag"
                                  href={row?.file_url}
                                  target="_blank"
                                >
                                  <div class="play-button"></div>
                                </a>
                              </Tooltip>
                              <div
                                className="download_icon"
                                style={{
                                  display: "flex",
                                  flexDirection: "row",
                                  justifyContent: "flex-end",
                                  width: "300px",
                                }}
                              >
                                <div
                                  className="chat_timestamp"
                                  style={{
                                    marginTop: "10px",
                                    display: "flex",
                                    justifyContent: "space-between",
                                  }}
                                >
                                  {row?.created_at ? (
                                    <span style={{ fontSize: "12px" }}>
                                      {new Date(
                                        row?.created_at
                                      ).toLocaleString()}
                                    </span>
                                  ) : (
                                    <span style={{ fontSize: "12px" }}>
                                      {new Date(
                                        row?.latest_chat_created_at
                                      ).toLocaleString()}
                                    </span>
                                  )}
                                  {row?.tick === "sent" ? (
                                    <p
                                      style={{
                                        color: "black",
                                        margin: "0",
                                        textAlign: "right",
                                        paddingLeft: "14px",
                                      }}
                                    >
                                      <DoneIcon />
                                    </p>
                                  ) : row?.tick === "read" ? (
                                    <p
                                      style={{
                                        color: "#365beee8",
                                        margin: "0",
                                        textAlign: "right",
                                        paddingLeft: "14px",
                                      }}
                                    >
                                      <DoneAllIcon />
                                    </p>
                                  ) : row?.tick === "delivered" ? (
                                    <p
                                      style={{
                                        color: "black",
                                        margin: "0",
                                        textAlign: "right",
                                        paddingLeft: "14px",
                                      }}
                                    >
                                      <DoneAllIcon />
                                    </p>
                                  ) : (
                                    ""
                                  )}
                                </div>
                              </div>
                            </div>
                          ) : (
                            <div
                              style={{
                                display: "flex",
                                flexDirection: "column",
                                alignItems: "flex-end",
                              }}
                            >
                              <Tooltip
                                title="Click on image to view"
                                arrow
                                followCursor
                              >
                                <div
                                  onClick={() => {
                                    setLinkOfTheDoc(row?.file_url);
                                    setOpenDoc(true);
                                  }}
                                >
                                  <img
                                    src={row?.file_url}
                                    alt="whatsapp_image"
                                    style={{
                                      width: "300px",
                                      height: "300px",
                                      padding: "20px 0px 0px 0px",
                                    }}
                                  />
                                </div>
                              </Tooltip>
                              <div
                                className="download_icon"
                                style={{
                                  display: "flex",
                                  flexDirection: "row",
                                  justifyContent: "space-between",
                                  width: "300px",
                                }}
                              >
                                <DownloadForOfflineIcon
                                  style={{ width: "32px", height: "32px" }}
                                  onClick={() => {
                                    handleDownloadFile(
                                      row?.file_url?.includes("http")
                                        ? `${row?.file_url}`
                                        : `https://report.redcliffelabs.com/${row?.file_url}`
                                    );
                                  }}
                                />
                                <div
                                  className="chat_timestamp"
                                  style={{
                                    marginTop: "10px",
                                    display: "flex",
                                    justifyContent: "space-between",
                                  }}
                                >
                                  {row?.created_at ? (
                                    <span style={{ fontSize: "12px" }}>
                                      {new Date(
                                        row?.created_at
                                      ).toLocaleString()}
                                    </span>
                                  ) : (
                                    <span style={{ fontSize: "12px" }}>
                                      {new Date(
                                        row?.latest_chat_created_at
                                      ).toLocaleString()}
                                    </span>
                                  )}
                                  {row?.tick === "sent" ? (
                                    <p
                                      style={{
                                        color: "black",
                                        margin: "0",
                                        textAlign: "right",
                                        paddingLeft: "14px",
                                      }}
                                    >
                                      <DoneIcon />
                                    </p>
                                  ) : row?.tick === "read" ? (
                                    <p
                                      style={{
                                        color: "#365beee8",
                                        margin: "0",
                                        textAlign: "right",
                                        paddingLeft: "14px",
                                      }}
                                    >
                                      <DoneAllIcon />
                                    </p>
                                  ) : row?.tick === "delivered" ? (
                                    <p
                                      style={{
                                        color: "black",
                                        margin: "0",
                                        textAlign: "right",
                                        paddingLeft: "14px",
                                      }}
                                    >
                                      <DoneAllIcon />
                                    </p>
                                  ) : (
                                    ""
                                  )}
                                </div>
                              </div>
                            </div>
                          )}
                        </>
                      )}
                      {row?.file_url === "" || row?.file_url === null ? (
                        <div
                          className="chat_timestamp"
                          style={{
                            marginTop: "10px",
                            display: "flex",
                            justifyContent: "space-between",
                          }}
                        >
                          {row?.created_at ? (
                            <span style={{ fontSize: "12px" }}>
                              {new Date(row?.created_at).toLocaleString()}
                            </span>
                          ) : (
                            <span style={{ fontSize: "12px" }}>
                              {new Date(
                                row?.latest_chat_created_at
                              ).toLocaleString()}
                            </span>
                          )}
                          {row?.tick === "sent" ? (
                            <p
                              style={{
                                color: "black",
                                margin: "0",
                                textAlign: "right",
                                paddingLeft: "14px",
                              }}
                            >
                              <DoneIcon />
                            </p>
                          ) : row?.tick === "read" ? (
                            <p
                              style={{
                                color: "#365beee8",
                                margin: "0",
                                textAlign: "right",
                                paddingLeft: "14px",
                              }}
                            >
                              <DoneAllIcon />
                            </p>
                          ) : row?.tick === "delivered" ? (
                            <p
                              style={{
                                color: "black",
                                margin: "0",
                                textAlign: "right",
                                paddingLeft: "14px",
                              }}
                            >
                              <DoneAllIcon />
                            </p>
                          ) : (
                            ""
                          )}
                        </div>
                      ) : (
                        ""
                      )}
                    </p>
                    {leadUnread?.length === index + 1 &&
                    leadUnread?.length < individualWhatsappChat?.count ? (
                      <IconButton
                        onClick={() => {
                          setLoadMoreChats(true);
                        }}
                      >
                        <Tooltip title="Load More Chats" arrow>
                          <ReplayIcon style={{ color: "#0E3F6C" }} />
                        </Tooltip>
                      </IconButton>
                    ) : leadUnread?.length === index + 1 &&
                      leadUnread?.length === individualWhatsappChat?.count ? (
                      <></>
                    ) : (
                      ""
                    )}
                  </>
                ))
              : ""}
            {tabs1 === 1 &&
            tabData?.length > 0 &&
            Object.keys(todays_positive_calls).length > 0
              ? todays_positive_calls.map((row) => (
                  <div
                    className="specificMessages"
                    style={{
                      alignSelf: "flex-start",
                      backgroundColor: "#fff",
                      borderRadius: "0px 10px 10px 10px",
                      margin: "20px 20px 0px 50px",
                    }}
                  >
                    <span
                      style={{
                        color: "#9E9E9E",
                      }}
                    >
                      {row?.by_user ? `User : ${row?.by_user} ` : null},
                      {row?.created_at
                        ? `Date : ${row?.created_at.substring(0, 10)}`
                        : null}
                      ,
                      {row?.created_at
                        ? `Time : ${row?.created_at.substring(11, 16)}`
                        : null}
                    </span>

                    <p style={{ color: "#707070" }}>{row?.comment}</p>
                  </div>
                ))
              : null}
          </div>
          {messageData?.id && tabData?.length > 0 && !whatsappTemplateShow ? (
            <div className="chat_footer">
              {tabs1 === 2 ? (
                <>
                  <label htmlFor="icon-button-file" key={key}>
                    <Input
                      id="icon-button-file"
                      type="file"
                      onChange={handleFileChange}
                      disabled={whatsAppTabs === "hold"}
                    />
                    <IconButton
                      component="span"
                      disabled={whatsAppTabs === "hold"}
                    >
                      <AttachFile />
                    </IconButton>
                  </label>
                </>
              ) : (
                ""
              )}
              {unassignedLeadId === messageData?.id ? (
                <h3
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    backgroundColor: "gray",
                    boxShadow: "rgba(0, 0, 0, 0.35) 0px 5px 15px",
                    padding: "10px",
                    borderRadius: "4px",
                    margin: "10px",
                  }}
                >
                  Lead Has been Unassigned
                </h3>
              ) : (
                <form onSubmit={handleSubmit}>
                  <input
                    value={chats}
                    onChange={(e) => setChats(e.target.value)}
                    placeholder="Type a message"
                    type="text"
                    disabled={
                      whatsAppTabs === "hold" ||
                      unassignedLeadId === messageData?.id
                    }
                  />
                </form>
              )}
              <IconButton
                disabled={
                  (messageType === "" && chats === "") ||
                  loadingIndividualChat ||
                  loadingChat
                }
              >
                <SendIcon onClick={(e) => sendMessage(e)} />
              </IconButton>
            </div>
          ) : messageData?.lead &&
            tabData?.length > 0 &&
            whatsappTemplateShow &&
            tabs1 === 2 ? (
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                border: "1px solid grey",
                borderRadius: "10px",
                backgroundColor: "#e5e4e4",
              }}
            >
              <div>
                <p
                  style={{
                    padding: "6px",
                    fontSize: "10px",
                    marginBottom: "6px",
                  }}
                >
                  <span style={{ fontSize: "10px" }}>
                    Customer Service window expired.
                  </span>{" "}
                  If a person initiates a chat with you, you may continue that
                  conversation via WhatsApp for up to 24 hours after the last
                  message sent to you by that person ("24-hour Window"). Outside
                  of the 24-hour Window, you may only initiate chats messages
                  via approved Message Templates.
                </p>
              </div>
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  paddingBottom: "4px",
                }}
              >
                <Button
                  size="small"
                  variant="contained"
                  color="secondary"
                  style={{ width: "350px", marginRight: "20px" }}
                  onClick={() => {
                    setStartChatModal(true);
                  }}
                >
                  Start Chat
                </Button>
                <Button
                  variant="contained"
                  style={{
                    width: "350px",
                    backgroundColor: "#d36109",
                    height: "28px",
                  }}
                  onClick={() => {
                    setWhatsappLeadSearch(messageData?.lead);
                    handleClickWhatsapp();
                  }}
                >
                  Click to Send WhatsApp Template
                </Button>
              </div>
            </div>
          ) : null}
        </div>

        <WhatsAppModal
          open={openWhatsapp}
          setOpen={setOpenWhatsapp}
          leadId={whatsappLeadSearch}
          messageSource={messageSource}
        />
        <WhatsAppChatStartModal
          open={startChatModal}
          setOpen={setStartChatModal}
          leadId={messageData?.id}
        />

        {openDoc && (
          <DocModal
            src={linkOfTheDoc}
            open={openDoc}
            setOpen={setOpenDoc}
            heading={false}
          />
        )}
      </div>
    </div>
  );
};

const mapStateToProps = (state) => ({
  whatsappComments: state.OffLineSupporteReducer.whatsappComments,
  individualWhatsappChat: state.OffLineSupporteReducer.individualWhatsappChat,
  todays_positive_calls: state.OffLineSupporteReducer.todays_positive_calls,
  loading: state.OffLineSupporteReducer.loading,
  loadingChat: state.OffLineSupporteReducer.loadingChat,
  loadingIndividualChat: state.OffLineSupporteReducer.loadingIndividualChat,
  whatsappDataFromPusher: state.loginReducer.whatsappDataFromPusher,
  failedReport: state.OffLineSupporteReducer.failedReport,
  latestBookingUsingLeadData:
    state.OffLineSupporteReducer.latestBookingUsingLeadData,
  userDetails: state.OffLineSupporteReducer.userDetails,
  signOutData: state.OffLineSupporteReducer.signOutData,
  chatAssignedFromPusher: state.loginReducer.chatAssignedFromPusher,
  chatUnassignedFromPusher: state.loginReducer.chatUnassignedFromPusher,
  whatsappStatusMessageId: state.loginReducer.whatsappStatusMessageId,
  startWhatsappChatData: state.loginReducer.startWhatsappChatData,
  agentsList: state.loginReducer.agentsList,
});

export default connect(mapStateToProps, {
  getWhatsappComments,
  getIndividualWhatsappChat,
  sendWhatsappComments,
  addComment,
  getPositiveCallsComments,
  signOutInWhatsappChat,
  resetLeadDetails,
  getUserDetails,
  clickToCall,
  getWhatsappStatus,
  getAgentList,
  postModuleInteraction,
})(WhatsAppChat);
